"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Width = exports.Thickness = exports.Alignment = exports.Color = exports.CustomDivider = void 0;
var react_1 = __importDefault(require("react"));
var Color;
(function (Color) {
    Color["DEFAULT"] = "currentColor";
    Color["PRIMARY"] = "text-primary";
    Color["SECONDARY"] = "text-secondary";
    Color["SUCCESS"] = "text-success";
    Color["WARNING"] = "text-warning";
    Color["DANGER"] = "text-danger";
    Color["INFO"] = "text-info";
    Color["DARK"] = "text-dark";
    Color["LIGHT"] = "text-light";
})(Color || (Color = {}));
exports.Color = Color;
var Alignment;
(function (Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
})(Alignment || (Alignment = {}));
exports.Alignment = Alignment;
var Thickness;
(function (Thickness) {
    Thickness["T1"] = "1px";
    Thickness["T2"] = "2px";
    Thickness["T3"] = "3px";
    Thickness["T4"] = "4px";
    Thickness["T5"] = "5px";
    Thickness["T6"] = "6px";
    Thickness["T8"] = "8px";
    Thickness["T10"] = "10px";
    Thickness["T12"] = "12px";
    Thickness["T16"] = "16px";
    Thickness["T24"] = "24px";
})(Thickness || (Thickness = {}));
exports.Thickness = Thickness;
var Width;
(function (Width) {
    Width["W10"] = "10%";
    Width["W25"] = "25%";
    Width["W33"] = "33%";
    Width["W50"] = "50%";
    Width["W66"] = "66%";
    Width["W75"] = "75%";
    Width["W100"] = "100%";
})(Width || (Width = {}));
exports.Width = Width;
var CustomDivider = function (_a) {
    var id = _a.id, _b = _a.color, color = _b === void 0 ? Color.DEFAULT : _b, // Varsayılan renk (gri ton)
    _c = _a.thickness, // Varsayılan renk (gri ton)
    thickness = _c === void 0 ? Thickness.T1 : _c, // Varsayılan kalınlık
    _d = _a.width, // Varsayılan kalınlık
    width = _d === void 0 ? Width.W100 : _d, // Varsayılan genişlik
    _e = _a.alignment, // Varsayılan genişlik
    alignment = _e === void 0 ? Alignment.CENTER : _e, // Varsayılan hizalama
    _f = _a.className, // Varsayılan hizalama
    className = _f === void 0 ? '' : _f, _g = _a.style, style = _g === void 0 ? {} : _g;
    var combinedClassName = "".concat(color, " ").concat(className).trim();
    // Hizalama stilini belirleme
    var alignmentStyle = {
        marginLeft: alignment === 'left' ? '0' : 'auto',
        marginRight: alignment === 'right' ? '0' : 'auto',
    };
    return (react_1.default.createElement("hr", { id: id || "custom-divider-".concat(Date.now()), 
        //className={`custom-divider ${className}`.trim()}
        className: "custom-divider ".concat(combinedClassName), style: __assign(__assign({ border: 'none', borderTop: "".concat(thickness, " solid"), // Çizgiyi oluştur
            width: width }, alignmentStyle), style) }));
};
exports.CustomDivider = CustomDivider;
exports.default = CustomDivider;
